import React from 'react';
import {useHistory} from "react-router-dom";

import {Row, Col, Layout} from 'antd';
import bgPic from './../../auth.png';

import Icon from '@ant-design/icons';

import './auth.scss';
import AuthService from "../../services/AuthService";
import {clearStorage} from "../../helpers/token";

const AuthPageWrapper = ({children, hasNavigation}) => {
  const history = useHistory();
  const BackSvg = () => (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path fill="#191D21" d="M10.071 5.293c.36.36.388.928.083 1.32l-.083.094-4.657 4.657H21c.552 0 1 .448 1 1 0 .513-.386.936-.883.993l-.117.007H5.414l4.657 4.657c.39.39.39 1.024 0 1.414-.36.36-.927.389-1.32.084l-.094-.084-6.364-6.364-.073-.081-.003-.004.076.085c-.04-.04-.075-.081-.107-.125l-.04-.061-.024-.041-.026-.053-.027-.06-.02-.054-.013-.047-.016-.065-.009-.052-.007-.06-.004-.07v-.038c0-.023.002-.047.004-.07l-.004.09c0-.051.004-.101.011-.15l.01-.052c.004-.022.009-.043.015-.065l.014-.046c.006-.02.013-.04.021-.059l.023-.052c.008-.019.018-.037.028-.056l.026-.045.042-.063.02-.026c.028-.035.054-.066.083-.094l6.364-6.364c.39-.39 1.024-.39 1.414 0z"/>
    </svg>
  );

  const handleBack = () => {
    AuthService.logout().then(({}) => {
      clearStorage();
      history.push('/login');
    });
  }

    return (
        <Row >
            <Col span={10}>
                <Layout style={{minHeight: '100vh', backgroundColor: 'white'}}>
                    {hasNavigation ? (
                        <div style={{margin: '0 auto', height: '100vh'}}>
                            <div className='back'>
                              <Icon onClick={handleBack} component={BackSvg} />
                            </div>
                            <div className='items'>
                              {children}
                            </div>
                        </div>
                    ) : (
                      <div style={{margin: 'auto'}}>
                        {children}
                      </div>
                    )}
                </Layout>
            </Col>
            <Col span={14}>
                <div className='auth-bg-pic' style={{backgroundImage: `url(${bgPic})`}} />
            </Col>
        </Row>
    )
};


export default AuthPageWrapper;